/* src/app/burden/burden-filters-presenter/burden-filters-presenter.component.scss */
:host ::ng-deep .p-multiselect {
  width: 100%;
}
:host ::ng-deep .p-multiselect-label {
  min-width: 10em;
}
:host ::ng-deep .button-bar {
  margin-top: 1em;
}
/*# sourceMappingURL=burden-filters-presenter.component.css.map */
